import { useMemo } from 'react';

import { UseOptionsQueryParams, UseOptionsQueryReturnType } from '@/components/FilterNew/types';
import { usePaginatedgetLabelCategoriesQuery } from '@/modules/tasks/graphql/queries/generated/paginatedgetLabelCategories';

import { getEntityFilterGroups } from '../../../utils';
import { getLabelCategoryOption } from '../utils';

const useLabelCategoryOptionsQuery = ({
  searchText,
}: UseOptionsQueryParams): UseOptionsQueryReturnType => {
  const [{ data, error, fetching }] = usePaginatedgetLabelCategoriesQuery();
  const alLabelCategories = data?.labelCategories.edges?.map((edge) => edge.node);
  const labelCategories = useMemo(() => {
    if (!searchText) {
      return alLabelCategories;
    }

    return alLabelCategories?.filter((labelCategory) =>
      labelCategory.name.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [searchText, alLabelCategories]);

  const groups = useMemo(
    () => getEntityFilterGroups(labelCategories, getLabelCategoryOption),
    [labelCategories],
  );

  return { error: error, groups, fetching };
};

export default useLabelCategoryOptionsQuery;
